import { ALL_DEVICES_MODAL_PROPS_CHANGED } from './types';

export const changeAllDevicesModalProps = props => ({
    type: ALL_DEVICES_MODAL_PROPS_CHANGED,
    payload: props,
});
